import { Spin, Table } from "antd";
import React, { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { BreadCrumb } from "../../../components/main/LayoutComponents";
import { Locale } from "../../../utils";
import {
  handleMutationError,
  showNotificationWithIcon,
} from "../../../utils/helpers/helpers";
import { getList, remove } from "../../../utils/http/dataProvider";
import { getUserInfo } from "../../../utils/redux/reducers/User";
import StaffListHeader from "./StaffListHeader";
import { staffListColumns } from "./staffListColumns";
import "./staffList.scss";

const i18n = Locale.getInstance();

const StaffList = () => {
  const user = useSelector((state) => getUserInfo(state));
  const queryClient = useQueryClient();
  const history = useHistory();
  const [keyword, setKeyword] = useState();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const { data, error, isLoading } = useQuery(
    ["merchant-employees", user.token, page, keyword],
    () =>
      getList("merchant-employee", {
        pagination: {
          perPage: 10,
          page,
        },
        sort: {
          field: "id",
          order: "desc",
        },
        filter: {
          keyword,
        },
        token: user.token,
      })
  );

  const deleteMutation = useMutation(remove, {
    onSuccess: () => {
      queryClient.invalidateQueries("merchant-employees");
      setLoading(false);
    },
    onError: (err) => {
      setLoading(false);
      handleMutationError(err);
    },
  });

  if (error) {
    showNotificationWithIcon(error?.data?.message);
  }

  const breadCrumbData = [
    {
      href: "/main/setting/staff",
      title: i18n.t("merchantStaff.title"),
    },
  ];

  if (isLoading) {
    return <Spin spinning={isLoading} />;
  }

  return (
    <>
      <BreadCrumb data={breadCrumbData} />
      <div className="merchant-staff">
        <StaffListHeader keyword={keyword} setKeyword={setKeyword} setPage={setPage} />
        <Table
          className="list"
          rowKey="id"
          loading={loading || deleteMutation.isLoading}
          columns={staffListColumns(
            deleteMutation,
            user.token,
            setLoading,
            history
          )}
          dataSource={data?.data}
          pagination={{
            current: data?.current_page || page,
            total: data?.total || 0,
            pageSize: 10,
            onChange: (nextPage) => setPage(nextPage),
            showQuickJumper: true,
          }}
        />
      </div>
    </>
  );
};

export default StaffList;
